// Copia um link de convite para a área de transferência. No modo apresentação o link aponta
// para a própria tela; na versão real viria com um token de convite gerado pela API.
export async function copyInviteLink(path: string): Promise<boolean> {
  const url = `${window.location.origin}${path}`;
  try {
    await navigator.clipboard.writeText(url);
    return true;
  } catch {
    return false;
  }
}
